import React from 'react';
import {BrowserRouter, Route, Routes } from 'react-router-dom'
import './App.css';

import Header from './Components/Header';
import Footer from './Components/Footer';
import Home from './Pages/Home';
import About from './Pages/About';
import FlightSearchDetail from './Pages/FlightSearchDetail';
import Destination from './Pages/Destination';
import Booking from './Pages/Booking';
import BookingDestination from './Pages/BookingDestination';
import ScrollToTop from './Components/ScrollToTop';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import TermsConditions from './Pages/TermsConditions';
import Hotels from './Pages/Hotels';
import HolidayPackages from './Pages/HolidayPackages';
import HajjUmrah from './Pages/HajjUmrah';
import TopDestination from './Pages/TopDestination';
import Contact from './Pages/Contact';
import Premium from './Pages/Premium';
import Business from './Pages/Business';
import FirstClass from './Pages/FirstClass';

export default function App() {
  return (
      <BrowserRouter>
        
        <Header />
        <ScrollToTop />
        <Routes>
            <Route path="/" exact element={<Home />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/hotels" element={<Hotels />} />
            <Route path="/holiday-packages" element={<HolidayPackages />} />
            <Route path="/hajj-umrah" element={<HajjUmrah />} />
            <Route path="/top-destinations" element={<TopDestination />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/flight-search" element={<FlightSearchDetail />} />
            <Route path="/flights/:from-to" element={<Destination />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/booking-destination" element={<BookingDestination />} />
            <Route path="/premium-flight" element={<Premium />} />
            <Route path="/busines-flight" element={<Business />} />
            <Route path="/first-class-flight" element={<FirstClass />} />
            <Route path="*" element={<p>404: Page not found</p>} />
        </Routes>
        <Footer />
        </BrowserRouter>
      );
}